module.exports = "/_next/static/images/award-electronic-city-a595fdae9fd63fee3537c37547c32d87.png";